module.exports = __webpack_public_path__ + "static/media/portfolio3.fcb365b9.png";